// src/contexts/PrivateRoutes.tsx

import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { hasPermission } from '../utils/roles';
import LoadingSpinner from '../components/common/LoadingSpinner';

interface PrivateRouteProps {
  requiredPermission?: string;
}

const PrivateRoutes = ({ requiredPermission }: PrivateRouteProps) => {
  const { isAuthenticated, isLoading, user } = useAuth();

   // If authentication is still loading, return a loading indicator (optional)
   if (isLoading) {
    return <LoadingSpinner />
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  if (requiredPermission && user && !hasPermission(user.role, requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return <Outlet />;
};

export default PrivateRoutes;